import { Link } from 'react-router-dom'
import { FaTwitter, FaPhone } from 'react-icons/fa'
import { HiLocationMarker } from 'react-icons/hi'
import logo from '../images/logo.png'

const Footer = () => {
  return (
    <>
      <footer
        id="footer"
        className="flex flex-col bg-gray-800 py-10 px-5 text-white md:flex-row md:justify-between xl:px-32 2xl:px-56"
      >
        <div>
          <Link to="/">
            <img
              src={logo}
              alt="Amgel Enterprises Limited"
              title="Amgel Enterprises Limited"
              className="w-40"
            />
          </Link>
        </div>
        <ul>
          <h3 className="font-bold text-2xl mb-5">Contacts</h3>
          <li>
            <a href="tel:0704597808" className="flex items-center text-xl">
              <FaPhone className="mr-3" />
              0704 597 808
            </a>
          </li>
          <li>
            <p className="flex items-center text-xl mt-5">
              <HiLocationMarker className="mr-3" />
              Located: Parklands
            </p>
          </li>
        </ul>
        <ul className="flex mt-5 mb-10">
          {/* <li className="mr-5 text-2xl">
            <a href="#">
              <GrFacebook />
            </a>
          </li> */}
          <li className="mr-5 text-white text-2xl">
            <a
              href="https://twitter.com/AmgelInnocent"
              target="_blank"
              rel="noopenner noreferrer"
            >
              <FaTwitter />
            </a>
          </li>
          {/* <li className="mr-5 text-white text-2xl">
            <a href="#">
              <FaInstagram />
            </a>
          </li>
          <li className="mr-5 text-white text-2xl">
            <Link to="/location">
              <HiLocationMarker />
            </Link>
          </li> */}
        </ul>
      </footer>

      <div className="bg-gray-800 text-left text-white py-2 px-5 2xl:pr-20">
        <p>Copyright &copy; Amgel Enterprises Limited, 2021</p>
      </div>
    </>
  )
}

export default Footer
